import { Link } from '@tanstack/react-router';

import { Button } from './ui/button';

export default function NotFound() {
  return (
    <div className="flex min-h-0 flex-1 flex-col items-center justify-center p-8">
      <div className="max-w-md space-y-6 text-center">
        <h1 className="text-foreground text-6xl font-bold">404</h1>
        <h2 className="text-foreground text-2xl font-semibold">Page Not Found</h2>
        <p className="text-muted-foreground">
          The page you&apos;re looking for doesn&apos;t exist or has been moved.
        </p>
        <Button asChild>
          <Link to="/">Go to Chat</Link>
        </Button>
      </div>
    </div>
  );
}
